import React from 'react';
import PropTypes from 'prop-types';
import { ContentSection } from '../../layout/components/';
import { CrossLinkBlock } from './';

const CrossLinksSection = props => {
  const { crossLinks, crossLinksTextual } = props;
  return (
    <ContentSection title="More from us" noMargin>
      {crossLinks.map((crosslink, index) => (
        <CrossLinkBlock
          key={index}
          image={crosslink.image}
          linkTarget={crosslink.link.url}
          linkLabel={crosslink.link.title}
          category={crosslink.category}
        >
          <h2>{crosslink.title}</h2>
          <p>{crosslink.body}</p>
        </CrossLinkBlock>
      ))}
      {crossLinksTextual &&
        crossLinksTextual.map((crosslink, index) => (
          <CrossLinkBlock
            key={index}
            linkTarget={crosslink.link.url}
            linkLabel={crosslink.link.title}
            category={crosslink.category}
          >
            <h2>{crosslink.title}</h2>
          </CrossLinkBlock>
        ))}
    </ContentSection>
  );
};

CrossLinksSection.propTypes = {
  crossLinks: PropTypes.array.isRequired,
  crossLinksTextual: PropTypes.array,
};

export default CrossLinksSection;



// WEBPACK FOOTER //
// ./src/modules/pages/components/CrossLinksSection.js